// extracted by mini-css-extract-plugin
export var cardWrapper = "_8q-0";